<template>
  <div id="tab-mawb" class="app-main-inner">
    <div class="form-card-wrapper">
      <el-card class="form-card" style="width: 100%;padding-bottom: 10px;">
        <el-form label-width="90px" label-position="left" style="height:100%;width: 1200px;">
          <div style="display: flex;justify-content: space-between">
            <el-form-item label="MAWB No." class="custom">
              <div style="display: flex;align-content: center;align-items: center;width: 400px">
                <el-input v-model="mblNo" no="1" :class="importDifferenceField.mblNo ? 'red-border' : ''" style="flex: 1" :disabled="true" />
                <el-tooltip no="2" :content="$t('queryJob.BillOfLadingInformationTracking')" placement="right">
                  <img :src="img.follow" style="width: 20px;height: 20px;cursor: pointer" :tip="$t('queryJob.BillOfLadingInformationTracking')" @click="showMBLDetailBtnClickHandler">
                </el-tooltip>
              </div>
            </el-form-item>
            <div>
              <span style="padding-right: 10px">Issuing Carrier's Agent Name and City</span>
              <el-button no="3" :disabled="!isEdit" type="primary" @click="jobNoTranscribeHandler"> {{ $t('SeaExport.CopyFromOtherBill') }} </el-button>
              <el-button no="4" :disabled="!isEdit" type="primary" @click="popUpAddressWindow"> {{ $t('SeaExport.CodeSearching') }} </el-button>
              <el-button no="5" :disabled="!isEdit" type="primary" @click="airlineBtnHandler">{{ $t("SeaExport.ResetInitialValue") }}</el-button>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between">
            <div style="flex:1;margin-right: 10px;">
              <el-form-item label="Shipper" class="custom">
                <div style="display: flex;width:500px;">
                  <cargo-input
                    ref="shipperCode"
                    v-model="form.shipperCode"
                    :disabled="!isEdit"
                    no="6"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                    :class="importDifferenceField.shipperCode ? 'red-border' : ''"
                  />
                  <cargo-company-select
                    ref="shipperId"
                    no="7"
                    :method-params="{shipper:true,active:true}"
                    :disabled="!isEdit"
                    :default-value="form.shipperId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    :class="importDifferenceField.shipperId ? 'red-border' : ''"
                    @change="data => {shipperChangeHandler(data)}"
                  />
                  <el-button :disabled="!isEdit" no="8" type="primary" style="margin-left: 5px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item class="label-none custom ">
                <cargo-input
                  ref="shipperLine1"
                  v-model="form.shipperLine1"
                  :disabled="!isEdit"
                  no="9"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine1 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine1','shipperLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine2"
                  v-model="form.shipperLine2"
                  :disabled="!isEdit"
                  no="10"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine2 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine2','shipperLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine3"
                  v-model="form.shipperLine3"
                  :disabled="!isEdit"
                  no="11"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine3 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine3','shipperLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine4"
                  v-model="form.shipperLine4"
                  :disabled="!isEdit"
                  no="12"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine4 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine4','shipperLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine5"
                  v-model="form.shipperLine5"
                  :disabled="!isEdit"
                  no="13"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine5 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine5','shipperLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine6"
                  v-model="form.shipperLine6"
                  :disabled="!isEdit"
                  no="14"
                  :maxlength="maxChars"
                  :class="importDifferenceField.shipperLine6 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine7"
                  v-model="form.shipperLine7"
                  :disabled="!isEdit"
                  no="140"
                  :maxlength="maxChars"
                  :class="importDifferenceField.shipperLine7 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                />
              </el-form-item>
              <el-form-item label="Consignee" class="custom">
                <div style="display: flex;width:500px;">
                  <cargo-input
                    ref="consigneeCode"
                    v-model="form.consigneeCode"
                    :disabled="!isEdit"
                    no="15"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                    :class="importDifferenceField.consigneeCode ? 'red-border' : ''"
                  />
                  <cargo-company-select
                    ref="consigneeId"
                    no="16"
                    :method-params="{consignee:true,active:true}"
                    :disabled="!isEdit"
                    :default-value="form.consigneeId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    :class="importDifferenceField.consigneeId ? 'red-border' : ''"
                    @change="data => {consigneeChangeHandler(data)}"
                  />
                  <el-button no="17" :disabled="!isEdit" type="primary" style="margin-left: 5px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine1"
                  v-model="form.consigneeLine1"
                  :disabled="!isEdit"
                  no="18"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine1 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine1','consigneeLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine2"
                  v-model="form.consigneeLine2"
                  :disabled="!isEdit"
                  no="19"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine2 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine2','consigneeLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine3"
                  v-model="form.consigneeLine3"
                  :disabled="!isEdit"
                  no="20"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine3 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine3','consigneeLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine4"
                  v-model="form.consigneeLine4"
                  :disabled="!isEdit"
                  no="21"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine4 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine4','consigneeLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine5"
                  v-model="form.consigneeLine5"
                  :disabled="!isEdit"
                  no="22"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine5 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine5','consigneeLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine6"
                  v-model="form.consigneeLine6"
                  :disabled="!isEdit"
                  no="23"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine6 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine6','consigneeLine7',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine7"
                  v-model="form.consigneeLine7"
                  :disabled="!isEdit"
                  no="24"
                  :maxlength="maxChars"
                  :class="importDifferenceField.consigneeLine7 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                />
              </el-form-item>
              <div style="display: flex;justify-content: space-between">
                <div style="display: flex;flex:1;flex-direction: column;margin-right: 10px;">
                  <span>Agent IATA Code </span>
                  <cargo-input
                    v-model="form.iataCode"
                    :disabled="!isEdit"
                    no="25"
                    :class="importDifferenceField.iataCode ? 'red-border' : ''"
                    :auto-uppercase="isUppercase"
                  />
                </div>
                <div style="display: flex;flex:1;flex-direction: column">
                  <span>Account No</span>
                  <cargo-input
                    v-model="form.accountCode"
                    :disabled="!isEdit"
                    no="26"
                    :class="importDifferenceField.accountCode ? 'red-border' : ''"
                    :auto-uppercase="isUppercase"
                  />
                </div>
              </div>
              <div style="display: flex;flex-direction: column">
                <span>Airport of Departure</span>
                <cargo-input
                  v-model="form.airportOfDeparture"
                  :disabled="!isEdit"
                  no="27"
                  :class="importDifferenceField.airportOfDeparture ? 'red-border' : ''"
                  :auto-uppercase="isUppercase"
                />
              </div>
            </div>
            <div style="flex: 1;">
              <el-form-item label="Notify" class="custom">
                <div style="display: flex;width:520px;margin-left: 30px">
                  <cargo-input
                    ref="notifyCode"
                    v-model="form.notifyCode"
                    :disabled="!isEdit"
                    no="28"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                    :class="importDifferenceField.notifyCode ? 'red-border' : ''"
                  />
                  <cargo-company-select
                    ref="notifyId"
                    no="29"
                    :method-params="{notify:true,active:true}"
                    :disabled="!isEdit"
                    :default-value="form.notifyId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    :class="importDifferenceField.notifyId ? 'red-border' : ''"
                    @change="data => {notifyChangeHandler(data)}"
                  />
                  <el-button no="30" :disabled="!isEdit" type="primary" style="margin-left: 5px" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                </div>
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine1"
                  v-model="form.notifyLine1"
                  :disabled="!isEdit"
                  no="31"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  style="margin-left: 120px;"
                  :class="importDifferenceField.notifyLine1 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine1','notifyLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine2"
                  v-model="form.notifyLine2"
                  :disabled="!isEdit"
                  no="32"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  style="margin-left: 120px;"
                  :class="importDifferenceField.notifyLine2 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine2','notifyLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine3"
                  v-model="form.notifyLine3"
                  :disabled="!isEdit"
                  no="33"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  style="margin-left: 120px;"
                  :class="importDifferenceField.notifyLine3 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine3','notifyLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine4"
                  v-model="form.notifyLine4"
                  :disabled="!isEdit"
                  no="34"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  style="margin-left: 120px;"
                  :class="importDifferenceField.notifyLine4 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine4','notifyLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine5"
                  v-model="form.notifyLine5"
                  :disabled="!isEdit"
                  no="35"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  style="margin-left: 120px;"
                  :class="importDifferenceField.notifyLine5 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine5','notifyLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine6"
                  v-model="form.notifyLine6"
                  :disabled="!isEdit"
                  no="36"
                  :maxlength="maxChars"
                  style="margin-left: 120px;"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine6 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @dblclick.native="showNotifyDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom custom-left'">
                <cargo-input
                  ref="notifyLine7"
                  v-model="form.notifyLine7"
                  :disabled="!isEdit"
                  no="360"
                  :maxlength="maxChars"
                  style="margin-left: 120px;"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine7 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @dblclick.native="showNotifyDialog"
                />
              </el-form-item>
              <div style="display: flex;flex-direction: column">
                <span>Issued By</span>
                <cargo-rich-textarea
                  v-model="form.issuedBy"
                  no="37"
                  :disabled="!isEdit"
                  :text-chars="0"
                  :auto-uppercase="true"
                  :warning-count="-1"
                  style="height: 110px;width: 610px"
                  :class="importDifferenceField.issuedBy ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog('Issued By',form.issuedBy,val=>{form.issuedBy=val})"
                />
              </div>
              <div style="display: flex;flex-direction: column">
                <span>Accounting info</span>
                <cargo-rich-textarea
                  v-model="form.accountingInfo"
                  no="38"
                  :disabled="!isEdit"
                  :text-chars="0"
                  :auto-uppercase="true"
                  :warning-count="-1"
                  style="height: 110px;width: 610px"
                  :class="importDifferenceField.accountingInfo ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog('Accounting Information',form.accountingInfo,val=>{form.accountingInfo=val})"
                />
              </div>
              <div style="display: flex;flex-direction: column">
                <span>Remark2</span>
                <cargo-rich-textarea
                  v-model="form.remark2"
                  no="39"
                  :disabled="!isEdit"
                  :auto-uppercase="true"
                  :text-chars="0"
                  :warning-count="-1"
                  style="height: 110px;width: 610px"
                  :class="importDifferenceField.remark2 ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog('Remark2',form.remark2,val=>{form.remark2=val})"
                />
              </div>
            </div>
            <div style="width: 300px; margin-left: 10px; padding-top: 5px;">
              <div style="display: flex">
                <span>Operation Requirements</span>
                <a v-if="airPortRequirementFileList && airPortRequirementFileList.length > 0" style="margin-left: 10px;text-decoration: underline;color: #0A0AFF" no="airPortRequirementText" @click="airPortRequirementClick">{{ airPortRequirementText }}</a>
              </div>
              <el-input
                v-model="airPortRequirement.operationRequirements"
                no="40"
                type="textarea"
                :rows="6"
                :disabled="true"
                style="height: 110px;width: 300px"
              />
            </div>
          </div>
          <div style="display: flex;justify-content: space-between">
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>
              <cargo-input
                v-model="form.podTo"
                :disabled="!isEdit"
                no="41"
                :class="importDifferenceField.podTo ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>By First Carrier</span>
              <cargo-input
                v-model="form.carrierBy"
                :disabled="!isEdit"
                no="42"
                :class="importDifferenceField.carrierBy ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>
              <cargo-input
                v-model="form.podTo1"
                :disabled="!isEdit"
                no="43"
                :class="importDifferenceField.podTo1 ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>By</span>
              <cargo-input
                v-model="form.carrierBy1"
                :disabled="!isEdit"
                no="44"
                :class="importDifferenceField.carrierBy1 ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>
              <cargo-input
                v-model="form.podTo2"
                :disabled="!isEdit"
                no="45"
                :class="importDifferenceField.podTo2 ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>By</span>
              <cargo-input
                v-model="form.carrierBy2"
                :disabled="!isEdit"
                no="46"
                :class="importDifferenceField.carrierBy2 ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>Currency</span>
              <!--              <el-select v-model="form.currency" no="47">-->
              <!--                <el-option-->
              <!--                  v-for="item in AirExportConstants.CURRENCY"-->
              <!--                  :key="item"-->
              <!--                  :value="item"-->
              <!--                />-->
              <!--              </el-select>-->

              <cargo-advance-select
                no="47"
                :select-type="selectTypeNames.basic_data_Currency"
                :disabled="!isEdit"
                filterable
                :clearable="false"
                :static-options="currencyList"
                :default-value="form.currency"
                :class="importDifferenceField.currency ? 'red-border' : ''"
                @parentCallBack="p=>{currencyChangeHandler(p.value)}"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>WT/VAL</span>
              <el-select v-model="form.wtVal" :disabled="!isEdit" no="48" :class="importDifferenceField.wtVal ? 'red-border' : ''" @change="cpChangeHandler('wtVal')">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>Other</span>
              <el-select v-model="form.other" :disabled="!isEdit" no="49" :class="importDifferenceField.other ? 'red-border' : ''" @change="cpChangeHandler('other')">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>D.V.Carrier</span>
              <cargo-input
                v-model="form.carriageDv"
                :disabled="!isEdit"
                no="50"
                :class="importDifferenceField.carriageDv ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>D.V. for Customs</span>
              <cargo-input
                v-model="form.dvForCustoms"
                :disabled="!isEdit"
                no="51"
                :class="importDifferenceField.dvForCustoms ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
          </div>
          <div style="display: flex;justify-content: flex-start">
            <div style="display: flex;flex-direction: column; flex: .7; margin-right: 10px;">
              <span>Airport of Destination</span>
              <cargo-input
                v-model="form.airportOfDestination"
                :disabled="!isEdit"
                no="52"
                :class="importDifferenceField.airportOfDestination ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>Flight No</span>
              <cargo-input
                v-model="job.voyageFlight"
                :disabled="!isEdit"
                no="53"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>ETD</span>
              <el-date-picker
                v-model="job.etd"
                :disabled="!isEdit"
                no="54"
                clearable
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>Amount of insurance</span>
              <cargo-input
                v-model="form.insuredAmount"
                :disabled="!isEdit"
                no="55"
                :class="importDifferenceField.insuredAmount ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>

          </div>
          <div>
            <div style="display: flex;flex-direction: column">
              <span>Handling Info</span>
              <cargo-rich-textarea
                v-model="form.handingInfo"
                no="56"
                :disabled="!isEdit"
                :text-chars="0"
                :warning-count="-1"
                :auto-uppercase="true"
                style="height: 110px"
                :class="importDifferenceField.handingInfo ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog('Handling Information',form.handingInfo,val=>{form.handingInfo=val})"
              />
            </div>
          </div>
          <hawb-part1
            ref="part1"
            :cargo-doc="form"
            :job="job"
            :action="action"
            style="width: 100%;"
            @chargeWeightChange="chargeWeightChange"
          />
        </el-form>

      </el-card>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="!isEdit"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="57" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="58"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="billAddressDialog.job" :params="billAddressDialog.params" @callback="codeSearchCallback" />
    <!-- 单号抄录 -->
    <copy-from-other-bill-dialog
      :visible.sync="copyFromOtherBillDialog.visible"
      :doc-type="copyFromOtherBillDialog.docType"
      :lob="copyFromOtherBillDialog.lob"
      @selected="transcribeEnterHandler"
    />
    <!--选择主单明细-->
    <mawb-info-dialog :visible.sync="mawbInfoDialog.visible" :items="mawbInfoDialog.items" :action="action" @selectCallBack="selectCallBack" />
    <!--操作要求-->
    <operation-requirement-dialog :files="operationRequirementDialog.files" :visible.sync="operationRequirementDialog.visible" />
  </div>
</template>

<script>
// import { TabMAWBPM } from './tabMAWBPM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import follow from '@/assets/follow.png'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import copyFromOtherBillDialog from '@/components/Cargo/Job/copyFromOtherBillDialog'
// import HawbPart1 from './components/HAWBPart1'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { cache, cacheName } from '@/utils/cacheManager'
// import mawbInfoDialog from './components/mawbInfoDialog'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { AirPortRequirement } from '@/class/model/mdm/AirPortRequirement'
import operationRequirementDialog from '@/components/Cargo/Job/operationRequirementDialog'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { TabMAWBPM } from '@/views/cargo/v0/AirImport/components/booking/tabs/tabMAWBPM'
import HawbPart1 from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/HAWBPart1.vue'
import mawbInfoDialog from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/mawbInfoDialog.vue'
import { AirImportJob } from '@/class/model/booking/AirImportJob'

export default {
  name: 'TabMawb',
  components: {
    billAddressDialog, copyFromOtherBillDialog, HawbPart1, cargoAdvanceSelect, cargoInput, cargoCompanySelect,
    cargoRichTextarea, operationRequirementDialog, mawbInfoDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      img: { follow },
      pm: new TabMAWBPM(this),
      AirExportConstants,
      selectTypeNames: TYPE_NAMES,
      job: {},
      addrPM: new BillAddressCommonPM(this),
      form: new AirCargoDoc().fillDefaultValue().getData(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      billAddressDialog: {
        visible: false,
        params: null,
        job: null
      },
      copyFromOtherBillDialog: {
        visible: false,
        docType: '',
        lob: 'AI'
      },
      maxChars: 34,
      warningCount: 0,
      isUppercase: true,
      NumberUtils,
      CargoDocUtil,
      iataPrice: null,
      mawbInfoDialog: {
        visible: false,
        items: []
      },
      mblNo: '',
      airPortRequirement: new AirPortRequirement().fillDefaultValue().getData(),
      airPortRequirementText: this.$t('queryJob.AttachmentDescription') + '：' + 0 + this.$t('CargoMsg.Cargo_Pcs'),
      airPortRequirementFileList: [],
      operationRequirementDialog: {
        visible: false,
        files: []
      },
      currencyList: [],
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      syncCustomerShippingInfoBothBolAndBasicTab: false
    }
  },
  computed: {
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !(Number(this.form.state) > 2)
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differenceMawbFields || {}
    }
  },
  watch: {

  },
  async created() {
    await this.createCurrency()
    this.notUppercaseShipperConsigneNotify = Number(this.context.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.syncCustomerShippingInfoBothBolAndBasicTab = Number(this.context.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1
  },
  methods: {
    async createCurrency() {
      const currencyList = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
      this.currencyList = []
      for (const c of currencyList) {
        const currency = { ...c }
        if (currency.code === 'RMB') {
          currency.code = 'CNY'
        }
        this.currencyList.push(currency)
      }
    },
    async onShow(row, isRefresh) {
      this.job = row
      await this.createCurrency()
      this.mblNo = AirExportUtils.mawbNoDispalyFormat(this.job.mbl)
      await this.pm.fillView()
      this.$refs.part1.fillView()
    },
    finishAdvanceText() {
      const value = this.advanceTextDialog.value.trim()
      if (value.split('\n').length > 7) {
        this.$message.warning(this.$t('queryJob.TheNotExceed7Lines'))
        return
      }
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(value)
      }
      this.advanceTextDialog.visible = false
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    jobNoTranscribeHandler() {
      this.copyFromOtherBillDialog.docType = this.form.docType
      this.copyFromOtherBillDialog.visible = true
    },
    popUpAddressWindow() {
      this.billAddressDialog.visible = true
      this.billAddressDialog.params = { ...this.form, mbl: true }
      this.billAddressDialog.job = this.job
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    showShipperDialog() {
      console.log('MAWB===>showShipperDialog')
      this.showAdvanceTextDialog(this.$t('Message.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify)
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify)
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Notify'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify)
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['shipperLine7'] || '')
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['consigneeLine7'] || '')
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['notifyLine7'] || '')
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      console.log('showAdvanceTextDialog===>isUppercase', isUppercase)
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.formatObj = formatObject ? { ...this.advanceTextDialog.formatObj, ...formatObject } : this.advanceTextDialog.formatObj
      this.advanceTextDialog.visible = true
    },
    async getSubmitData() {
      await this.fillModel(true)
      return {
        job: { ...this.job },
        airCargoDoc: this.job.airCargoDoc
      }
    },
    async fillModel(submitData = false) {
      if (this.$refs.part1) {
        await this.$refs.part1.fillModel(submitData)
      }
      CargoDocUtil.syncCargoDocSftToJob(this.job, this.form)
    },
    executeTask() {
      this.pm.executeTask()
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      if (this.form) {
        PrintTemplateUtil.buildPrintDataByAemawb(this.job, this.form, params)
        params.category = 'AIHAWB'
        params.ctx = new AirImportJob(this.job)
      }
      return params
    },
    cpChangeHandler(type = '') {
      const from = this.form
      switch (type) {
        case 'wtVal' :
          this.$refs.part1.wtValChanged(from.wtVal)
          break
        case 'other' :
          this.$refs.part1.otherChanged(from.other)
          break

        default : break
      }
    },
    async showMBLDetailBtnClickHandler() {
      await cache.load(cacheName.CONFIG)
      const consoleURL = cache.config.get('mawbNoDetailUrl')
      // 对按钮点击进行埋点
      // LogStores.sendFunctionClickLogStoresByLabel('CargoWare-空运操作-分单信息页签-MBL详情')
      if (!this.job.mbl || this.job.mbl.replace('-', '').length !== 11) {
        return
      } else {
        if (consoleURL) {
          const el = document.createElement('a')
          document.body.appendChild(el)
          el.href = consoleURL + '?MAWB=' + encodeURIComponent(this.job.mbl.replace('-', ''))
          el.target = '_blank'
          el.click()
          document.body.removeChild(el)
        } else {
          this.$message.warning(this.$t('queryJob.PleaseMaintainTheJumpAddress'))
        }
      }
    },
    transcribeEnterHandler(cargoDoc) {
      this.pm.transcribeEnterHandler(cargoDoc)
    },
    totalChargeHandler() {
      if (this.$refs.part1) {
        this.$refs.part1.totalChargeHandler()
      }
    },
    selectCallBack(mawbInfo) {
      this.pm.selectCallBackHandler(mawbInfo)
      this.mawbInfoDialog.visible = false
    },
    chargeWeightChange() {
      this.pm.chargeWeightChangeHandler()
    },
    // 重置初始值
    airlineBtnHandler() {
      this.pm.airlineBtnHandler()
    },
    airPortRequirementClick() {
      this.operationRequirementDialog.files = this.airPortRequirementFileList
      this.operationRequirementDialog.visible = true
    },
    // 发货人选择
    async shipperChangeHandler(data) {
      await AirCargoDocUtil.shipperChangeFunc(this.form, data)
    },
    // 收货人选择
    async consigneeChangeHandler(data) {
      await AirCargoDocUtil.consigneeChangeFunc(this.form, data)
    },
    // 通知人选择
    async notifyChangeHandler(data) {
      await AirCargoDocUtil.notifyChangeFunc(this.form, data)
    },
    syncDocSft(doc, shipper, consignee, notify) {
      if (this.form && doc) {
        // 业务模式【直单】时：基本页签收发通 同步到 MAWB页签收发通
        if (shipper) new AirCargoDoc(this.form).copyBasicShipper(doc, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (consignee) new AirCargoDoc(this.form).copyBasicConsignee(doc, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
        if (notify) new AirCargoDoc(this.form).copyBasicNotify(doc, true, this.syncCustomerShippingInfoBothBolAndBasicTab)
      }
    },
    // 切换币种
    currencyChangeHandler(value) {
      const oldCurrency = this.form.currency
      this.form.currency = value
      if (RateUtil.useAmountCarryRule() && oldCurrency && this.form.currency && oldCurrency !== this.form.currency) {
        this.$message.warning(this.$t('queryJob.CurrencyChangeCheckDiff', [this.form.currency]))
      }
    },
    endTabHandler() {
      return this.fillModel(false)
    }
  }
}
</script>

<style lang="scss">
  #app #tab-mawb {
    .el-form-item__content {
      width: 255px !important;
    }
    .label-none {
      .el-form-item__content {
        width: 490px !important;
      }
    }
    .custom-left  {
      margin-left: -90px;
    }
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #8cc8ff;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }
  }
</style>

<style lang="scss" scoped>
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
